export const MisakoFooter = () => {
  return (
    <footer className="hidden size-full bg-[#FAFAFA] px-[40px] pb-28 pt-[60px] lg:block">
      <div className="flex flex-wrap justify-between gap-4">
        <div className="space-y-5">
          <img
            style={
              {
                '--logo-desktop-height': '1.4rem',
                '--logo-mobile-height': '1.2rem'
              } as React.CSSProperties
            }
            width={285}
            height={70}
            src="https://static.byrever.com/ecommerces/misako-shopifytest/logo_1725447639.svg"
            alt="Misako"
            className="h-[var(--logo-mobile-height)] w-auto object-contain lg:h-[var(--logo-desktop-height)]"
          />
          <a
            href="mailto:tiendavirtual@misako.com"
            className="inline-block text-[13px] font-light underline underline-offset-4"
          >
            tiendavirtual@misako.com
          </a>
          <div className="flex max-w-40 flex-wrap gap-8 pt-4">
            <a href="https://www.facebook.com/Misakoshop/">
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                width={16}
                height={16}
                viewBox="0 0 18 18"
              >
                <path
                  fill="var(--color-body)"
                  d="M16.42.61c.27 0 .5.1.69.28.19.2.28.42.28.7v15.44c0 .27-.1.5-.28.69a.94.94 0 01-.7.28h-4.39v-6.7h2.25l.31-2.65h-2.56v-1.7c0-.4.1-.72.28-.93.18-.2.5-.32 1-.32h1.37V3.35c-.6-.06-1.27-.1-2.01-.1-1.01 0-1.83.3-2.45.9-.62.6-.93 1.44-.93 2.53v1.97H7.04v2.65h2.24V18H.98c-.28 0-.5-.1-.7-.28a.94.94 0 01-.28-.7V1.59c0-.27.1-.5.28-.69a.94.94 0 01.7-.28h15.44z"
                ></path>
              </svg>
            </a>
            <a href="https://www.instagram.com/misakoshop/">
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                viewBox="0 0 18 18"
                width={16}
                height={16}
              >
                <path
                  fill="var(--color-body)"
                  d="M8.77 1.58c2.34 0 2.62.01 3.54.05.86.04 1.32.18 1.63.3.41.17.7.35 1.01.66.3.3.5.6.65 1 .12.32.27.78.3 1.64.05.92.06 1.2.06 3.54s-.01 2.62-.05 3.54a4.79 4.79 0 01-.3 1.63c-.17.41-.35.7-.66 1.01-.3.3-.6.5-1.01.66-.31.12-.77.26-1.63.3-.92.04-1.2.05-3.54.05s-2.62 0-3.55-.05a4.79 4.79 0 01-1.62-.3c-.42-.16-.7-.35-1.01-.66-.31-.3-.5-.6-.66-1a4.87 4.87 0 01-.3-1.64c-.04-.92-.05-1.2-.05-3.54s0-2.62.05-3.54c.04-.86.18-1.32.3-1.63.16-.41.35-.7.66-1.01.3-.3.6-.5 1-.65.32-.12.78-.27 1.63-.3.93-.05 1.2-.06 3.55-.06zm0-1.58C6.39 0 6.09.01 5.15.05c-.93.04-1.57.2-2.13.4-.57.23-1.06.54-1.55 1.02C1 1.96.7 2.45.46 3.02c-.22.56-.37 1.2-.4 2.13C0 6.1 0 6.4 0 8.77s.01 2.68.05 3.61c.04.94.2 1.57.4 2.13.23.58.54 1.07 1.02 1.56.49.48.98.78 1.55 1.01.56.22 1.2.37 2.13.4.94.05 1.24.06 3.62.06 2.39 0 2.68-.01 3.62-.05.93-.04 1.57-.2 2.13-.41a4.27 4.27 0 001.55-1.01c.49-.49.79-.98 1.01-1.56.22-.55.37-1.19.41-2.13.04-.93.05-1.23.05-3.61 0-2.39 0-2.68-.05-3.62a6.47 6.47 0 00-.4-2.13 4.27 4.27 0 00-1.02-1.55A4.35 4.35 0 0014.52.46a6.43 6.43 0 00-2.13-.41A69 69 0 008.77 0z"
                ></path>
                <path
                  fill="var(--color-body)"
                  d="M8.8 4a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7.43a2.92 2.92 0 110-5.85 2.92 2.92 0 010 5.85zM13.43 5a1.05 1.05 0 100-2.1 1.05 1.05 0 000 2.1z"
                ></path>
              </svg>
            </a>
            <a href="https://es.pinterest.com/shopmisako/">
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                viewBox="0 0 17 18"
                width={16}
                height={16}
              >
                <path
                  fill="var(--color-body)"
                  d="M8.48.58a8.42 8.42 0 015.9 2.45 8.42 8.42 0 011.33 10.08 8.28 8.28 0 01-7.23 4.16 8.5 8.5 0 01-2.37-.32c.42-.68.7-1.29.85-1.8l.59-2.29c.14.28.41.52.8.73.4.2.8.31 1.24.31.87 0 1.65-.25 2.34-.75a4.87 4.87 0 001.6-2.05 7.3 7.3 0 00.56-2.93c0-1.3-.5-2.41-1.49-3.36a5.27 5.27 0 00-3.8-1.43c-.93 0-1.8.16-2.58.48A5.23 5.23 0 002.85 8.6c0 .75.14 1.41.43 1.98.28.56.7.96 1.27 1.2.1.04.19.04.26 0 .07-.03.12-.1.15-.2l.18-.68c.05-.15.02-.3-.11-.45a2.35 2.35 0 01-.57-1.63A3.96 3.96 0 018.6 4.8c1.09 0 1.94.3 2.54.89.61.6.92 1.37.92 2.32 0 .8-.11 1.54-.33 2.21a3.97 3.97 0 01-.93 1.62c-.4.4-.87.6-1.4.6-.43 0-.78-.15-1.06-.47-.27-.32-.36-.7-.26-1.13a111.14 111.14 0 01.47-1.6l.18-.73c.06-.26.09-.47.09-.65 0-.36-.1-.66-.28-.89-.2-.23-.47-.35-.83-.35-.45 0-.83.2-1.13.62-.3.41-.46.93-.46 1.56a4.1 4.1 0 00.18 1.15l.06.15c-.6 2.58-.95 4.1-1.08 4.54-.12.55-.16 1.2-.13 1.94a8.4 8.4 0 01-5-7.65c0-2.3.81-4.28 2.44-5.9A8.04 8.04 0 018.48.57z"
                ></path>
              </svg>
            </a>
            <a href="https://www.tiktok.com/@misakoshop">
              <svg
                role="presentation"
                focusable="false"
                width={16}
                height={16}
                viewBox="0 0 23 23"
              >
                <path
                  d="M20.027 10.168a5.125 5.125 0 0 1-4.76-2.294v7.893a5.833 5.833 0 1 1-5.834-5.834c.122 0 .241.011.361.019v2.874c-.12-.014-.237-.036-.36-.036a2.977 2.977 0 0 0 0 5.954c1.644 0 3.096-1.295 3.096-2.94L12.56 2.4h2.75a5.122 5.122 0 0 0 4.72 4.573v3.195"
                  fill="var(--color-body)"
                ></path>
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/misako--frag-comercio-internacional-sl-/?originalSubdomain=es">
              <svg
                role="presentation"
                focusable="false"
                width={16}
                height={16}
                viewBox="0 0 24 24"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.349 5.478a1.875 1.875 0 1 0-3.749 0 1.875 1.875 0 1 0 3.749 0ZM7.092 19.2H3.857V8.78h3.235V19.2ZM12.22 8.78H9.121V19.2h3.228v-5.154c0-1.36.257-2.676 1.94-2.676 1.658 0 1.68 1.554 1.68 2.763V19.2H19.2v-5.715c0-2.806-.605-4.963-3.877-4.963-1.573 0-2.629.863-3.06 1.683h-.044V8.78Z"
                  fill="var(--color-body)"
                ></path>
              </svg>
            </a>
          </div>
          <p className="pt-28 text-[13px] font-light text-neutral-500">
            © 2025 Misako
          </p>
        </div>
        <div className="flex flex-col gap-1.5 text-[14px] font-light tracking-wider">
          <p className="mb-2 text-[13px] font-light uppercase tracking-wider">
            Sobre nosotros
          </p>
          <a
            className="font-light tracking-wider"
            href="https://www.misako.com/pages/tiendas"
          >
            Nuestras tiendas
          </a>
          <a
            className="font-light tracking-wider"
            href="https://misako.ofertas-trabajo.infojobs.net/ofertas"
          >
            Trabaja con nosotros
          </a>
          <a
            className="font-light tracking-wider"
            href="https://www.misako.com/blogs/news"
          >
            Misako Blog
          </a>
          <a
            className="font-light tracking-wider"
            href="https://www.misako.com/pages/sobre-la-marca"
          >
            Sobre la marca
          </a>
        </div>
        <div className="flex flex-col gap-1.5 text-[14px] font-light tracking-wider">
          <p className="mb-2 text-[13px] font-light uppercase tracking-wider">
            INFORMACIÓN
          </p>
          <a
            className="font-light tracking-wider"
            href="https://www.misako.com/policies/privacy-policy"
          >
            Política de privacidad
          </a>
          <a
            className="font-light tracking-wider"
            href="https://www.misako.com/policies/privacy-policy"
          >
            Política de cookies
          </a>
          <a
            className="font-light tracking-wider"
            href="https://www.misako.com/policies/terms-of-service"
          >
            Términos y condiciones
          </a>
          <a
            className="font-light tracking-wider"
            href="https://www.misako.com/policies/terms-of-service"
          >
            Política de envíos
          </a>
        </div>
        <div className="flex flex-col gap-1.5 text-[14px] font-light tracking-wider">
          <p className="mb-2 text-[13px] font-light uppercase tracking-wider">
            SPECIAL EVENTS
          </p>
          <a
            className="font-light tracking-wider"
            href="https://www.misako.com/collections/rebajas-online"
          >
            Promociones
          </a>
          <a
            className="font-light tracking-wider"
            href="https://www.misako.com/collections/dia-del-padre"
          >
            Día del padre
          </a>
          <a
            className="font-light tracking-wider"
            href="https://www.misako.com/collections/outlet"
          >
            Oulet
          </a>
        </div>
        <div className="flex flex-col gap-1.5 text-[14px] font-light tracking-wider">
          <p className="mb-2 text-[13px] font-light uppercase tracking-wider">
            SOPORTE
          </p>
          <a
            className="text-[14px] font-light tracking-wider"
            href="https://www.misako.com/policies/refund-policy"
          >
            Devoluciones
          </a>
          <a
            className="text-[14px] font-light tracking-wider"
            href="https://www.misako.com/policies/shipping-policy"
          >
            Seguimiento del pedido
          </a>
          <a
            className="text-[14px] font-light tracking-wider"
            href="https://www.misako.com/pages/contact"
          >
            Contacto
          </a>
        </div>
        <div>
          <p className="mb-2 max-w-56 text-[13px] font-[400] uppercase leading-none tracking-wider">
            DESCARGA LA APP Y DISFRUTA DE LAS VENTAJAS
          </p>
          <div className="flex gap-4">
            <a href="https://apps.apple.com/us/app/misako-shop-online/id1538755997">
              {' '}
              <svg
                width="90"
                height="40"
                viewBox="0 0 133 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M127.337 39.1771H4.89912C2.1572 39.1771 0 37.0199 0 34.278V4.89911C0.00790179 2.15719 2.1572 0 4.89912 0H127.337C130.079 0 132.236 2.15719 132.236 4.89911V34.2859C132.236 36.933 130.079 39.185 127.337 39.185V39.1771Z"
                  fill="#010101"
                ></path>
                <path
                  d="M127.337 0.782277C129.589 0.782277 131.454 2.6471 131.454 4.89911V34.2859C131.454 36.5379 129.589 38.4027 127.337 38.4027H4.89912C2.64711 38.4027 0.782318 36.5379 0.782318 34.2859V4.89911C0.782318 2.6471 2.64711 0.782277 4.89912 0.782277H127.337ZM127.337 0H4.89912C2.1572 0 0 2.15719 0 4.89911V34.2859C0 37.0278 2.1572 39.185 4.89912 39.185H127.337C130.079 39.185 132.236 37.0278 132.236 34.2859V4.89911C132.236 2.25201 130.079 0 127.337 0Z"
                  fill="#A8A6A6"
                ></path>
                <path
                  d="M66.7072 21.3506C64.3524 21.3506 62.4955 23.1127 62.4955 25.5623C62.4955 28.0118 64.3604 29.7739 66.7072 29.7739C69.054 29.7739 70.9188 28.0118 70.9188 25.5623C70.9188 23.1127 69.054 21.3506 66.7072 21.3506ZM66.7072 28.0119C65.435 28.0119 64.3524 26.9372 64.3524 25.4675C64.3524 23.9977 65.4271 22.9231 66.7072 22.9231C67.9873 22.9231 69.0619 23.9029 69.0619 25.4675C69.0619 26.9372 67.9873 28.0119 66.7072 28.0119ZM57.5964 21.3506C55.2417 21.3506 53.3847 23.1127 53.3847 25.5623C53.3847 28.0118 55.2496 29.7739 57.5964 29.7739C59.9432 29.7739 61.8081 28.0118 61.8081 25.5623C61.8081 23.0179 59.9432 21.3506 57.5964 21.3506ZM57.5964 28.0119C56.3242 28.0119 55.2417 26.9372 55.2417 25.4675C55.2417 23.9977 56.3163 22.9231 57.5964 22.9231C58.8765 22.9231 59.9512 23.9029 59.9512 25.4675C59.9512 26.9372 58.8765 28.0119 57.5964 28.0119ZM46.7235 22.6228V24.3849H50.9352C50.8404 25.3647 50.4453 26.147 49.9554 26.6369C49.3706 27.2217 48.3908 27.9091 46.7235 27.9091C44.0764 27.9091 42.1168 25.8547 42.1168 23.2076C42.1168 20.5605 44.1712 18.506 46.7235 18.506C48.0984 18.506 49.1731 19.0907 49.9554 19.7782L51.2276 18.506C50.1529 17.5262 48.778 16.7439 46.8183 16.7439C43.2941 16.7439 40.252 19.6834 40.252 23.2076C40.252 26.7318 43.2862 29.6712 46.8183 29.6712C48.778 29.6712 50.145 29.0865 51.3224 27.8064C52.4997 26.629 52.887 24.9697 52.887 23.6896C52.887 23.2945 52.8869 22.9073 52.7921 22.6149H46.7157L46.7235 22.6228ZM91.1948 23.9977C90.7997 23.0179 89.8199 21.3506 87.6706 21.3506C85.5213 21.3506 83.7514 23.0179 83.7514 25.5623C83.7514 27.917 85.5134 29.7739 87.8682 29.7739C89.733 29.7739 90.9025 28.5966 91.2976 27.9091L89.9226 26.9293C89.4327 27.6168 88.848 28.1067 87.8682 28.1067C86.8883 28.1067 86.3036 27.7116 85.8137 26.8345L91.4003 24.4797L91.2027 23.9898L91.1948 23.9977ZM85.5134 25.3727C85.5134 23.8081 86.7856 22.9231 87.6706 22.9231C88.3581 22.9231 89.0456 23.3182 89.2352 23.8081L85.5134 25.3727ZM80.9067 29.3868H82.7715V17.1469H80.9067V29.3868ZM77.9672 22.2356C77.4773 21.7457 76.695 21.2558 75.7152 21.2558C73.6607 21.2558 71.7011 23.1206 71.7011 25.4675C71.7011 27.8143 73.5659 29.5843 75.7152 29.5843C76.695 29.5843 77.4773 29.0944 77.8724 28.6045H77.9672V29.1892C77.9672 30.7538 77.0822 31.6388 75.7152 31.6388C74.6406 31.6388 73.8504 30.8565 73.6608 30.169L72.0962 30.8565C72.5861 31.9311 73.7635 33.3061 75.8179 33.3061C77.8724 33.3061 79.7372 32.0339 79.7372 28.9996V21.5561H77.9751V22.2435L77.9672 22.2356ZM75.81 28.0119C74.5378 28.0119 73.4553 26.9372 73.4553 25.4675C73.4553 23.9977 74.5299 22.9231 75.81 22.9231C77.0901 22.9231 78.0621 23.9977 78.0621 25.4675C78.0621 26.9372 77.0822 28.0119 75.81 28.0119ZM99.7129 17.139H95.3038V29.3789H97.1686V24.7721H99.7129C101.767 24.7721 103.727 23.3024 103.727 20.9556C103.727 18.6008 101.767 17.139 99.7129 17.139ZM99.8078 23.0179H97.1607V18.8063H99.8078C101.183 18.8063 101.965 19.9836 101.965 20.8607C101.87 21.9354 101.08 23.0179 99.8078 23.0179ZM111.076 21.2558C109.701 21.2558 108.334 21.8406 107.844 23.1206L109.511 23.8081C109.906 23.1206 110.491 22.9231 111.178 22.9231C112.158 22.9231 113.043 23.5078 113.138 24.4877V24.5825C112.846 24.3849 112.063 24.0926 111.273 24.0926C109.511 24.0926 107.749 25.0724 107.749 26.8345C107.749 28.5018 109.219 29.5764 110.783 29.5764C112.056 29.5764 112.648 28.9917 113.13 28.399H113.225V29.3789H114.987V24.6773C114.79 22.5201 113.122 21.2479 111.068 21.2479L111.076 21.2558ZM110.878 28.0119C110.293 28.0119 109.408 27.7195 109.408 26.9372C109.408 25.9574 110.483 25.665 111.368 25.665C112.15 25.665 112.545 25.8626 113.035 26.0601C112.838 27.2375 111.858 28.0198 110.878 28.0198V28.0119ZM121.166 21.5482L119.112 26.8345H119.017L116.86 21.5482H114.9L118.132 28.9917L116.267 33.1085H118.132L123.126 21.5482H121.166ZM104.707 29.3868H106.572V17.1469H104.707V29.3868Z"
                  fill="white"
                ></path>
                <path
                  d="M10.1929 7.34863C9.90057 7.74372 9.79785 8.13091 9.79785 8.81837V30.3666C9.79785 30.9513 9.99539 31.4412 10.2878 31.7415L10.3826 31.8363L22.5276 19.6912V19.4937L10.185 7.34863H10.1929Z"
                  fill="#60C6F2"
                ></path>
                <path
                  d="M26.4477 23.8001L22.4336 19.786V19.4936L26.4477 15.4795L26.5425 15.5743L31.3389 18.3162C32.7138 19.0985 32.7138 20.3707 31.3389 21.153L26.4398 23.8001H26.4477Z"
                  fill="url(#paint0_linear_208_4991)"
                ></path>
                <path
                  d="M26.5501 23.7053L22.4332 19.5885L10.1934 31.8284C10.6833 32.3183 11.3707 32.3183 12.2478 31.9232L26.5501 23.6974"
                  fill="url(#paint1_linear_208_4991)"
                ></path>
                <path
                  d="M26.5501 15.4797L12.2478 7.34871C11.3628 6.8588 10.6833 6.95362 10.1934 7.44353L22.4332 19.5886L26.5501 15.4718V15.4797Z"
                  fill="url(#paint2_linear_208_4991)"
                ></path>
                <path
                  d="M40.457 12.7298V6.85083H42.2192C43.1042 6.85083 43.8864 7.1432 44.3763 7.63311C44.9611 8.21784 45.1586 8.9053 45.1586 9.7903C45.1586 10.6753 44.8662 11.3549 44.3763 11.9475C43.8864 12.4374 43.1042 12.7298 42.2192 12.7298H40.457ZM41.2393 12.0423H42.314C43.0014 12.0423 43.4913 11.8448 43.8785 11.4576C44.2736 11.0625 44.4632 10.4778 44.4632 9.7903C44.4632 9.10284 44.2657 8.51811 43.8785 8.12302C43.4913 7.72793 42.8987 7.53829 42.314 7.53829H41.2393V12.0423Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M46.2334 12.7298V6.85083H47.0157V12.7298H46.2334Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M50.0574 12.8324C49.6623 12.8324 49.1724 12.7376 48.7852 12.4373C48.3902 12.145 48.0978 11.7499 48.0029 11.26L48.6904 10.9676C48.7853 11.26 48.9828 11.5523 49.1803 11.7499C49.4727 11.9474 49.7651 12.0423 50.0653 12.0423C50.3656 12.0423 50.6501 11.9474 50.9503 11.7499C51.1479 11.5523 51.3454 11.3548 51.3454 11.0624C51.3454 10.7701 51.2506 10.4777 50.9503 10.2802C50.7528 10.0826 50.3656 9.88506 49.8757 9.79024C49.3858 9.5927 48.9907 9.39515 48.6983 9.20551C48.4059 8.91314 48.3032 8.62078 48.3032 8.22569C48.3032 7.8306 48.5007 7.44341 48.7931 7.15104C49.0855 6.85868 49.5754 6.66113 50.0653 6.66113C50.5552 6.66113 50.9503 6.75595 51.2427 7.05622C51.5351 7.34859 51.7326 7.54613 51.8274 7.8385L51.14 8.13087C51.0451 7.93332 50.9424 7.73578 50.7449 7.64095C50.5473 7.44341 50.255 7.44341 49.9626 7.44341C49.6702 7.44341 49.4727 7.53823 49.1803 7.64095C49.0855 7.8385 48.9828 8.03604 48.9828 8.32841C48.9828 8.52596 49.0776 8.7235 49.2752 8.91314C49.4727 9.11069 49.7651 9.20551 50.1602 9.30823C50.4525 9.40305 50.6501 9.50578 50.8476 9.6006C51.0451 9.69542 51.2427 9.79814 51.4323 9.99569C51.6299 10.0905 51.8274 10.2881 51.9222 10.5804C52.0171 10.8728 52.1198 11.0703 52.1198 11.3627C52.1198 11.6551 52.025 11.9474 51.9222 12.145C51.8195 12.3425 51.6299 12.5401 51.4323 12.6349C51.14 12.6349 50.9424 12.7297 50.7449 12.7297C50.5473 12.8245 50.255 12.8245 50.0574 12.8245V12.8324Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M53.8741 12.73H53.0918V6.85107H55.0515C55.5414 6.85107 55.9365 7.04862 56.3237 7.34099C56.7108 7.63335 56.9084 8.12326 56.9084 8.61317C56.9084 9.10308 56.7108 9.49817 56.3237 9.88536C55.9286 10.1777 55.5414 10.3753 55.0515 10.3753H53.8741V12.73ZM53.8741 9.593H55.1463C55.4387 9.593 55.731 9.49817 55.9286 9.30063C56.1261 9.10308 56.2209 8.81072 56.2209 8.61317C56.2209 8.32081 56.1261 8.12326 55.9286 7.92572C55.731 7.72817 55.4387 7.63335 55.1463 7.63335H53.8741V9.593Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M62.6926 11.9474C62.1078 12.5322 61.4204 12.8324 60.5354 12.8324C59.6504 12.8324 58.9708 12.5401 58.3782 11.9474C57.7934 11.3627 57.4932 10.6752 57.4932 9.79024C57.4932 8.90524 57.7855 8.22568 58.3782 7.63305C58.9629 7.04831 59.6504 6.74805 60.5354 6.74805C61.4204 6.74805 62.0999 7.04041 62.6926 7.63305C63.2773 8.21778 63.5776 8.90524 63.5776 9.79024C63.5776 10.6752 63.2852 11.3548 62.6926 11.9474ZM58.9708 11.4575C59.3659 11.8526 59.9507 12.145 60.5354 12.145C61.1201 12.145 61.7127 11.9474 62.0999 11.4575C62.495 11.0624 62.7874 10.4777 62.7874 9.79024C62.7874 9.10278 62.5898 8.51805 62.0999 8.12296C61.7048 7.72787 61.1201 7.4355 60.5354 7.4355C59.9507 7.4355 59.358 7.63305 58.9708 8.12296C58.5757 8.51805 58.2833 9.10278 58.2833 9.79024C58.2833 10.4777 58.4809 11.0624 58.9708 11.4575Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M64.6523 12.7298V6.85083H65.5373L68.3741 11.4576V6.85083H69.1564V12.7298H68.3741L65.3398 7.93338V12.7298H64.6523Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M70.5312 12.7298V6.85083H71.3135V12.7298H70.5312Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M72.5859 12.7298V6.85083H74.7431C75.233 6.85083 75.6281 7.04837 75.9205 7.34074C76.2128 7.63311 76.4104 8.0282 76.4104 8.51811C76.4104 8.81047 76.3156 9.00802 76.2128 9.30039C76.118 9.49793 75.9205 9.69548 75.6281 9.7903C75.9205 9.88512 76.118 10.0827 76.3156 10.2802C76.5131 10.4778 76.6079 10.7701 76.6079 11.1652C76.6079 11.6551 76.4104 12.0502 76.118 12.3426C75.7229 12.6349 75.3357 12.8325 74.8458 12.8325H72.5938V12.7377L72.5859 12.7298ZM73.3682 9.40311H74.7431C75.0355 9.40311 75.233 9.30829 75.4306 9.11074C75.6281 8.9132 75.7229 8.71565 75.7229 8.52601C75.7229 8.33637 75.6281 8.13092 75.4306 7.94128C75.233 7.74373 75.0355 7.64891 74.7431 7.64891H73.3682V9.41101V9.40311ZM73.3682 12.0502H74.9327C75.2251 12.0502 75.4227 11.9554 75.6202 11.7578C75.8177 11.5603 75.9126 11.3628 75.9126 11.0704C75.9126 10.8728 75.8177 10.5805 75.6202 10.3829C75.4227 10.1854 75.2251 10.0906 74.9327 10.0906H73.463V12.0502H73.3682Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M77.5801 12.73V6.85107H78.3623V12.0426H80.9067V12.73H77.5801Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M85.3161 7.54625H82.669V9.41108H85.1186V10.0985H82.669V11.9634H85.3161V12.7456H81.8867V6.8667H85.3161V7.55416V7.54625Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M91.8825 7.54625H89.2354V9.41108H91.685V10.0985H89.2354V11.9634H91.8825V12.7456H88.4531V6.8667H91.8825V7.55416V7.54625Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M93.0596 12.7298V6.85083H93.9446L96.7813 11.4576V6.85083H97.5636V12.7298H96.7813L93.747 7.93338V12.7298H93.0596Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <defs>
                  <linearGradient
                    id="paint0_linear_208_4991"
                    x1="30.4539"
                    y1="19.6358"
                    x2="6.77222"
                    y2="19.6358"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#FEE00C"></stop>
                    <stop offset="0.19" stopColor="#FDCF0B"></stop>
                    <stop offset="0.55" stopColor="#FAB41F"></stop>
                    <stop offset="0.83" stopColor="#F6A122"></stop>
                    <stop offset="1" stopColor="#F59A22"></stop>
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_208_4991"
                    x1="24.306"
                    y1="21.8326"
                    x2="2.03082"
                    y2="44.1078"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#E94649"></stop>
                    <stop offset="1" stopColor="#C7196D"></stop>
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_208_4991"
                    x1="1.91228"
                    y1="-5.00179"
                    x2="20.0943"
                    y2="13.1881"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#289F6F"></stop>
                    <stop offset="0.32" stopColor="#4DAC6E"></stop>
                    <stop offset="0.74" stopColor="#6BB86B"></stop>
                    <stop offset="1" stopColor="#77BC6A"></stop>
                  </linearGradient>
                </defs>
              </svg>
            </a>
            <a href="https://apps.apple.com/us/app/misako-shop-online/id1538755997">
              {' '}
              <svg
                width="90"
                height="40"
                viewBox="0 0 133 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M131.359 34.5546C131.359 36.6249 129.676 38.308 127.606 38.308H4.63821C2.56003 38.308 0.876953 36.6328 0.876953 34.5546V4.63052C0.876953 2.55234 2.56003 0.877164 4.63821 0.869263H127.598C129.676 0.869263 131.359 2.55234 131.359 4.62261V34.5467V34.5546Z"
                  fill="white"
                ></path>
                <path
                  d="M127.598 39.1771H4.63835C2.07817 39.1771 0.00790179 37.1068 0 34.5545V4.63045C0 2.07027 2.07817 0 4.63835 0H127.598C130.158 0 132.229 2.07027 132.236 4.63045V34.5545C132.236 37.1068 130.158 39.1771 127.606 39.1771H127.598Z"
                  fill="#A6A6A6"
                ></path>
                <path
                  d="M131.359 34.5546C131.359 36.6249 129.676 38.308 127.606 38.308H4.63821C2.56003 38.308 0.876953 36.6328 0.876953 34.5546V4.63052C0.876953 2.55234 2.56003 0.877164 4.63821 0.869263H127.598C129.676 0.869263 131.359 2.55234 131.359 4.62261V34.5467V34.5546Z"
                  fill="#010101"
                ></path>
                <path
                  d="M29.5286 19.3831C29.497 16.2224 32.1125 14.6894 32.2311 14.6183C30.7534 12.4611 28.454 12.1688 27.648 12.1451C25.72 11.9396 23.8473 13.2987 22.8674 13.2987C21.8876 13.2987 20.3547 12.1688 18.7269 12.2004C16.6329 12.232 14.6654 13.4489 13.5907 15.3295C11.3703 19.1697 13.0297 24.8195 15.1553 27.9249C16.222 29.45 17.4626 31.1489 19.0904 31.0857C20.6865 31.0224 21.2792 30.0742 23.1993 30.0742C25.1194 30.0742 25.6647 31.0857 27.324 31.0461C29.0308 31.0224 30.1055 29.5211 31.1327 27.9802C32.3654 26.234 32.8553 24.5193 32.879 24.4323C32.8395 24.4165 29.5602 23.1681 29.5286 19.3831ZM26.3916 10.0985C27.245 9.02385 27.8377 7.56992 27.6717 6.09229C26.4311 6.1476 24.8824 6.94568 23.9895 7.99662C23.1993 8.92113 22.496 10.4304 22.6778 11.8527C24.0685 11.9554 25.4987 11.1494 26.3916 10.0985Z"
                  fill="white"
                ></path>
                <path
                  d="M127.598 0H61.7363L87.5357 39.1771H127.598C130.158 39.1771 132.228 37.1068 132.236 34.5466V4.63045C132.236 2.07027 130.158 0 127.598 0Z"
                  fill="url(#paint0_linear_208_5011)"
                ></path>
                <path
                  d="M52.5941 30.8644H50.3658L49.1489 27.032H44.9136L43.752 30.8644H41.5869L45.7828 17.8265H48.3746L52.5941 30.8644ZM48.7854 25.428L47.6792 22.0223C47.5607 21.6746 47.3394 20.8528 47.0233 19.5648H46.9838C46.8574 20.118 46.6441 20.9398 46.3675 22.0223L45.285 25.428H48.7854ZM63.3801 26.0443C63.3801 27.6405 62.9455 28.9048 62.0763 29.8372C61.3019 30.6669 60.33 31.0778 59.1763 31.0778C57.9278 31.0778 57.0349 30.6353 56.4897 29.7424V34.6731H54.4036V24.5509C54.4036 23.5473 54.3799 22.5201 54.3246 21.4613H56.1657L56.2842 22.9547H56.3238C57.0191 21.8327 58.078 21.2716 59.5003 21.2716C60.6065 21.2716 61.5389 21.7062 62.2738 22.5833C63.0166 23.4604 63.388 24.6141 63.388 26.0443H63.3801ZM61.2545 26.1233C61.2545 25.2067 61.049 24.4561 60.6381 23.8555C60.1877 23.2392 59.5793 22.931 58.8207 22.931C58.3071 22.931 57.833 23.1048 57.4221 23.4446C57.0033 23.7844 56.7267 24.2348 56.6003 24.7879C56.545 24.9934 56.5134 25.2067 56.5055 25.4201V26.9925C56.5055 27.6721 56.7188 28.2489 57.1376 28.723C57.5564 29.1971 58.1017 29.4263 58.7733 29.4263C59.5635 29.4263 60.1719 29.1181 60.6144 28.5176C61.0569 27.9091 61.2703 27.1111 61.2703 26.1154L61.2545 26.1233ZM74.1976 26.0443C74.1976 27.6405 73.763 28.9048 72.8938 29.8372C72.1115 30.6669 71.1475 31.0778 69.9939 31.0778C68.7454 31.0778 67.8525 30.6353 67.3072 29.7424V34.6731H65.2212V24.5509C65.2212 23.5473 65.1975 22.5201 65.1422 21.4613H66.9833L67.1018 22.9547H67.1413C67.8367 21.8327 68.8955 21.2716 70.3178 21.2716C71.4241 21.2716 72.3486 21.7062 73.0914 22.5833C73.8341 23.4604 74.2055 24.6141 74.2055 26.0443H74.1976ZM72.0641 26.1233C72.0641 25.2067 71.8587 24.4561 71.4399 23.8555C70.9895 23.2392 70.381 22.931 69.6225 22.931C69.1089 22.931 68.6347 23.1048 68.216 23.4446C67.7972 23.7844 67.5206 24.2348 67.3942 24.7879C67.3309 25.0487 67.2993 25.2541 67.2993 25.4201V26.9925C67.2993 27.6721 67.5127 28.2489 67.9315 28.723C68.3503 29.1892 68.8955 29.4263 69.5672 29.4263C70.3573 29.4263 70.9658 29.1181 71.4083 28.5176C71.8508 27.9091 72.0641 27.1111 72.0641 26.1154V26.1233ZM86.2873 27.2059C86.2873 28.3121 85.9002 29.2208 85.1258 29.9162C84.2803 30.6748 83.095 31.054 81.57 31.054C80.1635 31.054 79.0414 30.7854 78.1959 30.2402L78.6779 28.5018C79.5945 29.047 80.5981 29.3157 81.6964 29.3157C82.4866 29.3157 83.095 29.1339 83.5375 28.7862C83.9721 28.4307 84.1934 27.9565 84.1934 27.3639C84.1934 26.8345 84.0116 26.392 83.6481 26.0285C83.2847 25.665 82.692 25.3332 81.8465 25.025C79.5629 24.1716 78.4172 22.931 78.4172 21.2874C78.4172 20.2207 78.8202 19.3436 79.6261 18.6561C80.4321 17.9687 81.4989 17.6289 82.8264 17.6289C84.0116 17.6289 84.9994 17.8344 85.7895 18.2452L85.268 19.952C84.5252 19.549 83.6956 19.3515 82.7631 19.3515C82.0283 19.3515 81.4515 19.5332 81.0327 19.8967C80.685 20.2207 80.5111 20.6158 80.5111 21.082C80.5111 21.5956 80.7087 22.0223 81.1117 22.3621C81.4594 22.6702 82.0915 23.01 83.0081 23.3656C84.1302 23.816 84.9598 24.3454 85.4814 24.9539C86.0108 25.5623 86.2794 26.313 86.2794 27.2138L86.2873 27.2059ZM93.2093 23.0258H90.9099V27.5931C90.9099 28.7546 91.3129 29.3315 92.1268 29.3315C92.4982 29.3315 92.8063 29.2999 93.0513 29.2366L93.1066 30.8249C92.6957 30.975 92.1505 31.054 91.4788 31.054C90.657 31.054 90.0091 30.8012 89.5429 30.2955C89.0767 29.7898 88.8475 28.9522 88.8475 27.759V23.0179H87.4726V21.4534H88.8475V19.7308L90.902 19.1144V21.4534H93.2014V23.0258H93.2093ZM103.576 26.0838C103.576 27.5299 103.166 28.7151 102.336 29.6396C101.475 30.5957 100.321 31.0699 98.8907 31.0699C97.4605 31.0699 96.4095 30.6116 95.5878 29.6949C94.766 28.7783 94.3551 27.6247 94.3551 26.234C94.3551 24.8432 94.7818 23.5869 95.6194 22.6544C96.4649 21.722 97.6027 21.2637 99.0329 21.2637C100.463 21.2637 101.522 21.722 102.36 22.6386C103.158 23.5236 103.561 24.6694 103.561 26.0759L103.576 26.0838ZM101.411 26.1312C101.411 25.2699 101.222 24.5351 100.85 23.9108C100.416 23.1681 99.7836 22.7888 98.9697 22.7888C98.1558 22.7888 97.4921 23.1602 97.0575 23.9108C96.6861 24.5272 96.4965 25.2778 96.4965 26.1707C96.4965 27.0636 96.6861 27.7748 97.0575 28.3911C97.5079 29.1339 98.14 29.5132 98.9539 29.5132C99.7678 29.5132 100.376 29.1339 100.835 28.3753C101.222 27.7432 101.411 27.0004 101.411 26.1391V26.1312ZM110.372 23.2945C110.151 23.255 109.937 23.2392 109.716 23.2392C108.981 23.2392 108.412 23.5157 108.009 24.0689C107.662 24.5588 107.488 25.1751 107.488 25.9258V30.8565H105.402V24.4165C105.402 23.4288 105.386 22.4411 105.339 21.4534H107.156L107.235 23.255H107.29C107.512 22.6386 107.859 22.1408 108.333 21.7615C108.768 21.4376 109.297 21.2558 109.843 21.2558C110.032 21.2558 110.214 21.2716 110.364 21.2953V23.2866L110.372 23.2945ZM119.72 25.7124C119.72 26.0285 119.696 26.3446 119.641 26.6607H113.375C113.398 27.5931 113.699 28.3042 114.283 28.7941C114.813 29.2287 115.492 29.45 116.33 29.45C117.254 29.45 118.108 29.2999 118.866 29.0075L119.19 30.4535C118.298 30.8407 117.247 31.0382 116.038 31.0382C114.576 31.0382 113.438 30.6116 112.6 29.7503C111.771 28.8969 111.352 27.7432 111.352 26.2972C111.352 24.8511 111.739 23.6975 112.513 22.7572C113.327 21.7536 114.418 21.2479 115.801 21.2479C117.183 21.2479 118.179 21.7536 118.882 22.7572C119.435 23.5552 119.712 24.543 119.712 25.7124H119.72ZM117.729 25.1672C117.744 24.5509 117.602 24.0136 117.326 23.5632C116.962 22.9784 116.409 22.694 115.658 22.694C114.979 22.694 114.418 22.9784 113.999 23.5473C113.651 23.9977 113.446 24.543 113.383 25.1751H117.736L117.729 25.1672Z"
                  fill="white"
                ></path>
                <path
                  d="M42.2207 12.7298V6.85083H43.9828C44.8678 6.85083 45.6501 7.1432 46.14 7.63311C46.7247 8.21784 46.9223 8.9053 46.9223 9.7903C46.9223 10.6753 46.6299 11.3549 46.14 11.9475C45.6501 12.4374 44.8678 12.7298 43.9828 12.7298H42.2207ZM43.003 12.0423H44.0777C44.7651 12.0423 45.255 11.8448 45.6422 11.4576C46.0373 11.0625 46.2269 10.4778 46.2269 9.7903C46.2269 9.10284 46.0294 8.51811 45.6422 8.12302C45.255 7.72793 44.6624 7.53829 44.0777 7.53829H43.003V12.0423Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M47.9971 12.7298V6.85083H48.7793V12.7298H47.9971Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M51.8211 12.8324C51.426 12.8324 50.9361 12.7376 50.5489 12.4373C50.1538 12.145 49.8614 11.7499 49.7666 11.26L50.4541 10.9676C50.5489 11.26 50.7465 11.5523 50.944 11.7499C51.2364 11.9474 51.5287 12.0423 51.829 12.0423C52.1293 12.0423 52.4137 11.9474 52.714 11.7499C52.9115 11.5523 53.1091 11.3548 53.1091 11.0624C53.1091 10.7701 53.0143 10.4777 52.714 10.2802C52.5165 10.0826 52.1293 9.88506 51.6394 9.79024C51.1495 9.5927 50.7543 9.39515 50.462 9.20551C50.1696 8.91314 50.0669 8.62078 50.0669 8.22569C50.0669 7.8306 50.2644 7.44341 50.5568 7.15104C50.8491 6.85868 51.3391 6.66113 51.829 6.66113C52.3189 6.66113 52.714 6.75595 53.0064 7.05622C53.2987 7.34859 53.4963 7.54613 53.5911 7.8385L52.9036 8.13087C52.8088 7.93332 52.7061 7.73578 52.5085 7.64095C52.311 7.44341 52.0186 7.44341 51.7263 7.44341C51.4339 7.44341 51.2364 7.53823 50.944 7.64095C50.8492 7.8385 50.7465 8.03604 50.7465 8.32841C50.7465 8.52596 50.8413 8.7235 51.0388 8.91314C51.2364 9.11069 51.5287 9.20551 51.9238 9.30823C52.2162 9.40305 52.4137 9.50578 52.6113 9.6006C52.8088 9.69542 53.0064 9.79814 53.196 9.99569C53.3935 10.0905 53.5911 10.2881 53.6859 10.5804C53.7807 10.8728 53.8835 11.0703 53.8835 11.3627C53.8835 11.6551 53.7886 11.9474 53.6859 12.145C53.5832 12.3425 53.3935 12.5401 53.196 12.6349C52.9036 12.6349 52.7061 12.7297 52.5085 12.7297C52.311 12.8245 52.0186 12.8245 51.8211 12.8245V12.8324Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M55.6378 12.7298H54.8555V6.85083H56.8151C57.3051 6.85083 57.7001 7.04837 58.0873 7.34074C58.4745 7.63311 58.672 8.12302 58.672 8.61293C58.672 9.10284 58.4745 9.49793 58.0873 9.88512C57.6922 10.1775 57.3051 10.375 56.8151 10.375H55.6378V12.7298ZM55.6378 9.59275H56.91C57.2023 9.59275 57.4947 9.49793 57.6922 9.30039C57.8898 9.10284 57.9846 8.81047 57.9846 8.61293C57.9846 8.32056 57.8898 8.12302 57.6922 7.92547C57.4947 7.72793 57.2023 7.63311 56.91 7.63311H55.6378V9.59275Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M64.4562 11.9474C63.8715 12.5322 63.1841 12.8324 62.2991 12.8324C61.4141 12.8324 60.7345 12.5401 60.1418 11.9474C59.5571 11.3627 59.2568 10.6752 59.2568 9.79024C59.2568 8.90524 59.5492 8.22568 60.1418 7.63305C60.7266 7.04831 61.4141 6.74805 62.2991 6.74805C63.1841 6.74805 63.8636 7.04041 64.4562 7.63305C65.041 8.21778 65.3412 8.90524 65.3412 9.79024C65.3412 10.6752 65.0489 11.3548 64.4562 11.9474ZM60.7345 11.4575C61.1296 11.8526 61.7143 12.145 62.2991 12.145C62.8838 12.145 63.4764 11.9474 63.8636 11.4575C64.2587 11.0624 64.551 10.4777 64.551 9.79024C64.551 9.10278 64.3535 8.51805 63.8636 8.12296C63.4685 7.72787 62.8838 7.4355 62.2991 7.4355C61.7143 7.4355 61.1217 7.63305 60.7345 8.12296C60.3394 8.51805 60.047 9.10278 60.047 9.79024C60.047 10.4777 60.2446 11.0624 60.7345 11.4575Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M66.416 12.7298V6.85083H67.301L70.1378 11.4576V6.85083H70.92V12.7298H70.1378L67.1035 7.93338V12.7298H66.416Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M72.2949 12.7298V6.85083H73.0772V12.7298H72.2949Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M74.3496 12.7298V6.85083H76.5068C76.9967 6.85083 77.3918 7.04837 77.6841 7.34074C77.9765 7.63311 78.174 8.0282 78.174 8.51811C78.174 8.81047 78.0792 9.00802 77.9765 9.30039C77.8817 9.49793 77.6841 9.69548 77.3918 9.7903C77.6841 9.88512 77.8817 10.0827 78.0792 10.2802C78.2768 10.4778 78.3716 10.7701 78.3716 11.1652C78.3716 11.6551 78.1741 12.0502 77.8817 12.3426C77.4866 12.6349 77.0994 12.8325 76.6095 12.8325H74.3575V12.7377L74.3496 12.7298ZM75.1319 9.40311H76.5068C76.7991 9.40311 76.9967 9.30829 77.1942 9.11074C77.3918 8.9132 77.4866 8.71565 77.4866 8.52601C77.4866 8.33637 77.3918 8.13092 77.1942 7.94128C76.9967 7.74373 76.7991 7.64891 76.5068 7.64891H75.1319V9.41101V9.40311ZM75.1319 12.0502H76.6964C76.9888 12.0502 77.1863 11.9554 77.3839 11.7578C77.5814 11.5603 77.6762 11.3628 77.6762 11.0704C77.6762 10.8728 77.5814 10.5805 77.3839 10.3829C77.1863 10.1854 76.9888 10.0906 76.6964 10.0906H75.2267V12.0502H75.1319Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M79.3438 12.73V6.85107H80.126V12.0426H82.6704V12.73H79.3438Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M87.0788 7.54625H84.4317V9.41108H86.8813V10.0985H84.4317V11.9634H87.0788V12.7456H83.6494V6.8667H87.0788V7.55416V7.54625Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M93.6452 7.54625H90.9981V9.41108H93.4477V10.0985H90.9981V11.9634H93.6452V12.7456H90.2158V6.8667H93.6452V7.55416V7.54625Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <path
                  d="M94.8232 12.73V6.85107H95.7082L98.545 11.4578V6.85107H99.3273V12.73H98.545L95.5107 7.93362V12.73H94.8232Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.2"
                  strokeMiterlimit="10"
                ></path>
                <defs>
                  <linearGradient
                    id="paint0_linear_208_5011"
                    x1="96.5927"
                    y1="40.6079"
                    x2="96.5927"
                    y2="-100.527"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#1B1B1B" stopOpacity="0.1"></stop>
                    <stop
                      offset="0.12"
                      stopColor="#202121"
                      stopOpacity="0.15"
                    ></stop>
                    <stop
                      offset="0.31"
                      stopColor="#353535"
                      stopOpacity="0.23"
                    ></stop>
                    <stop
                      offset="0.53"
                      stopColor="#585858"
                      stopOpacity="0.32"
                    ></stop>
                    <stop
                      offset="0.78"
                      stopColor="#868686"
                      stopOpacity="0.42"
                    ></stop>
                    <stop
                      offset="1"
                      stopColor="#B4B4B4"
                      stopOpacity="0.51"
                    ></stop>
                  </linearGradient>
                </defs>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
